module.exports = __webpack_public_path__ + "img/slide-dog1.95cbbfba.png";